module.exports = __webpack_public_path__ + "static/media/4.153917e9.jpg";